// extracted by mini-css-extract-plugin
export default {"adultBlur":"styles_adultBlur__XQH40","messageBlock":"styles_messageBlock__zTCiJ"};